var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297 297",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 297 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.5,116.187c32.029,0,58.086-26.057,58.086-58.086S180.529,0.014,148.5,0.014S90.414,26.072,90.414,58.101   S116.471,116.187,148.5,116.187z M120.402,51.894c3.429-3.427,8.985-3.427,12.414,0l8.387,8.388L164.184,37.3   c3.429-3.427,8.985-3.427,12.414,0c3.428,3.428,3.428,8.986,0,12.414L147.41,78.902c-1.714,1.713-3.96,2.571-6.207,2.571   c-2.247,0-4.493-0.857-6.207-2.571l-14.594-14.594C116.974,60.88,116.974,55.321,120.402,51.894z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.165,84.869c18.839,0,34.166-15.327,34.166-34.166S53.004,16.537,34.165,16.537S0,31.864,0,50.703   S15.326,84.869,34.165,84.869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.367,133.777v70.955c0,16.297 13.211,29.508 29.508,29.508h38.457v52.407c0,3.992 3.236,7.229 7.229,7.229h34.077c3.992,0 7.229-3.236 7.229-7.229v-75.595c0-13.757-11.152-24.908-24.908-24.908h-29.995v-52.367c0-17.009-13.789-30.798-30.798-30.798-17.01-0.001-30.799,13.788-30.799,30.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.835,84.869c18.839,0 34.165-15.327 34.165-34.166s-15.326-34.166-34.165-34.166-34.166,15.327-34.166,34.166 15.327,34.166 34.166,34.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.036,133.777v52.367h-29.994c-13.757,0-24.909,11.152-24.909,24.908v75.595c0,3.992 3.236,7.229 7.229,7.229h34.077c3.992,0 7.229-3.236 7.229-7.229v-52.407h38.457c16.297,0 29.508-13.211 29.508-29.508v-70.955c0-17.009-13.789-30.798-30.798-30.798-17.01-0.001-30.799,13.788-30.799,30.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.616,151.813c4.848,0 8.777-3.93 8.777-8.777 0-4.848-3.93-8.777-8.777-8.777h-102.232c-4.848,0-8.777,3.93-8.777,8.777 0,4.848 3.93,8.777 8.777,8.777h42.338v136.395c0,4.848 3.93,8.777 8.777,8.777s8.777-3.93 8.777-8.777v-136.395h42.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/Meeting.e998ab8e1ee3a5cc354f754bac48900e.svg";
export { ForwardRef as ReactComponent };